import React from 'react';
import { MessageType } from '@common/model/dialog/message/messageType';
import { DialogMessageRenderer, DialogMessageText, InteractiveMessageLayout } from '@cp/entities/dialog';
import { Button } from '@cp/ds/src/components/button';
import { useStartTraining } from 'src/features/client/training';

export const TrainingMessageRenderer: DialogMessageRenderer<MessageType.Training> = ({ isPreview }) => {
  const [startTraining] = useStartTraining();
  return isPreview ? (
    <DialogMessageText>Хотите пройти обучение сейчас?</DialogMessageText>
  ) : (
    <InteractiveMessageLayout>
      <DialogMessageText>
        Хотите пройти обучение сейчас?
        <br />
        (Займет ~20 мин.)
      </DialogMessageText>
      <Button color="gray" onClick={startTraining} size="extraSmall">
        Да, хочу начать
      </Button>
    </InteractiveMessageLayout>
  );
};
